import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import "../styles/home.css";

function Privacy() {
  return (
    <>
      <Header />

      {/* ======================================================
         FULL-WIDTH PAGE SHELL
         ====================================================== */}
      <main className="home-shell">
        <div className="home-container">

          {/* ======================================================
             PRIVACY POLICY
             ====================================================== */}
          <section className="section-block offset-left">
            <div className="section-card wide">

              <h2 className="section-title">privacy policy</h2>

              <p>
                this privacy policy (“policy”) describes how prufyy (“we”, “us”,
                “our”, or the “platform”) collects, uses, stores, processes, and
                discloses information in connection with your access to and use of
                the prufyy website, applications, dashboards, and related services
                (collectively, the “services”).
              </p>

              <p>
                by accessing or using prufyy, you acknowledge that you have read,
                understood, and agreed to the practices described in this policy.
                if you do not agree, you must discontinue use of the services
                immediately.
              </p>

              <h3>1. scope and applicability</h3>
              <p>
                this policy applies to all users of prufyy, including founders,
                evaluators, investors, incubators, accelerators, and any other
                individual or entity accessing the services in any capacity
                (“users”). this policy governs information collected directly by
                prufyy through the services and does not apply to third-party
                websites, tools, or services that may be linked or referenced.
              </p>

              <h3>2. definitions</h3>
              <p>
                “personal data” means any information that identifies or may
                reasonably be linked to an identifiable individual. “usage data”
                means technical, behavioral, and interaction data generated through
                use of the services. “content” means any information, documents,
                files, text, data, or materials uploaded, submitted, or generated by
                users within the platform.
              </p>

              <h3>3. information we collect</h3>
              <p>
                prufyy may collect and process the following categories of
                information:
              </p>
              <ul className="bullet-list">
                <li>account and identity information provided during registration</li>
                <li>profile, startup, and evaluator-related information</li>
                <li>content uploaded or generated within the services</li>
                <li>communications sent to or received from prufyy</li>
                <li>usage data, interaction logs, and system-generated metadata</li>
              </ul>

              <h3>4. use of information</h3>
              <p>
                information collected by prufyy may be used for purposes including,
                but not limited to:
              </p>
              <ul className="bullet-list">
                <li>providing, operating, and maintaining the services</li>
                <li>facilitating startup evaluation and review workflows</li>
                <li>improving platform functionality and user experience</li>
                <li>monitoring usage patterns and system integrity</li>
                <li>complying with legal, regulatory, or contractual obligations</li>
              </ul>

              <h3>5. data visibility and sharing</h3>
              <p>
                user content and information may be visible to other users strictly
                in accordance with the platform’s sharing, permission, and access
                controls. prufyy does not publicly disclose private user information
                unless explicitly directed by the user or required by law.
              </p>

              <p>
                prufyy may disclose information where necessary to comply with
                applicable laws, enforce agreements, protect rights or safety, or
                respond to lawful requests by authorities.
              </p>

              <h3>6. data retention</h3>
              <p>
                prufyy retains information for as long as reasonably necessary to
                fulfill the purposes described in this policy, unless a longer
                retention period is required or permitted by law. retention periods
                may vary depending on the nature of the data and applicable
                obligations.
              </p>

              <h3>7. data security</h3>
              <p>
                prufyy implements commercially reasonable administrative, technical,
                and organizational measures designed to protect information against
                unauthorized access, disclosure, alteration, or destruction.
                however, no system can be guaranteed to be completely secure, and
                prufyy makes no absolute representations regarding security.
              </p>

              <h3>8. user responsibilities</h3>
              <p>
                users are solely responsible for the accuracy, legality, and
                appropriateness of content they submit to prufyy. users must ensure
                that they have the necessary rights and permissions to share any
                information uploaded to the platform.
              </p>

              <h3>9. third-party services</h3>
              <p>
                the services may integrate with or link to third-party services.
                prufyy is not responsible for the privacy practices, content, or
                security of such third parties, and users access them at their own
                risk.
              </p>

              <h3>10. international use</h3>
              <p>
                prufyy may be accessed from jurisdictions with differing data
                protection laws. by using the services, you acknowledge and consent
                to the processing of information in accordance with this policy,
                regardless of location.
              </p>

              <h3>11. limitation of liability</h3>
              <p>
                to the maximum extent permitted by law, prufyy shall not be liable
                for any indirect, incidental, consequential, or punitive damages
                arising from or related to the handling of information under this
                policy.
              </p>

              <h3>12. changes to this policy</h3>
              <p>
                prufyy reserves the right to modify this policy at any time. changes
                will be effective upon posting. continued use of the services
                constitutes acceptance of the revised policy.
              </p>

              <h3>13. contact</h3>
              <p>
                for privacy-related inquiries, concerns, or requests, you may contact
                us at:
              </p>
              <p>
                <strong>email:</strong>{" "}
                <a href="mailto:support@prufyy.com">support@prufyy.com</a>
              </p>

            </div>
          </section>

        </div>
      </main>

      <Footer />
    </>
  );
}

export default Privacy;
